module.exports = __webpack_public_path__ + "static/media/import-icon-blue-light.9dc25837.svg";